import { render, staticRenderFns } from "./teamRuleModal.vue?vue&type=template&id=6b235f81&scoped=true"
import script from "./teamRuleModal.vue?vue&type=script&lang=js"
export * from "./teamRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b235f81",
  null
  
)

export default component.exports